module.exports = __webpack_public_path__ + "static/media/diversity_inclusion.5731f645.jpg";